import { render, staticRenderFns } from "./Motorbike.vue?vue&type=template&id=894f629c&"
import script from "./Motorbike.vue?vue&type=script&lang=ts&"
export * from "./Motorbike.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports